export const VALID_ANALYSIS_STATUSES = {
    ANALYSIS_NOT_STARTED: 'ANALYSIS_NOT_STARTED',
    ANALYSIS_PENDING: 'ANALYSIS_PENDING',
    ANALYSIS_IN_PROGRESS: 'ANALYSIS_IN_PROGRESS',
    ANALYSIS_COMPLETE: 'ANALYSIS_COMPLETE',
    ADMINISTRATIVE_REVIEW: 'ADMINISTRATIVE_REVIEW',
};

const activeStates = [
    VALID_ANALYSIS_STATUSES.ANALYSIS_PENDING,
    VALID_ANALYSIS_STATUSES.ANALYSIS_IN_PROGRESS,
    VALID_ANALYSIS_STATUSES.ADMINISTRATIVE_REVIEW,
];

export const hasActiveAnalysisStatus = status => activeStates.includes(status);
